import { createSelector } from "reselect";

const documentsSelector = (state) => state.documents;
const authSelector = (state) => state.auth;
const dealsSelector = (state) => state.deals;

// documents
export const getDocumentsList = createSelector(
  documentsSelector,
  (documents) => documents.documentsList
);

export const getDocumentsFilters = createSelector(
  documentsSelector,
  (documents) => documents.filters
);

// users

export const getDocumentUpdatedStatus = createSelector(
  documentsSelector,
  (documents) => documents.updatedStatus
);

export const getAuthUser = createSelector(authSelector, (auth) => auth.user);

export const isSessionExpired = createSelector(
  authSelector,
  (auth) => auth.isSessionExpired || false
);

export const getUserRole = createSelector(
  getAuthUser,
  (user) => (user && user.role_id) || false
);

export const getUserId = createSelector(
  getAuthUser,
  (user) => (user && user.id) || -1
);

export const getDealsData = createSelector(
  dealsSelector,
  (deals) => deals.dealsData
);

export const getDealById = (id) =>
  createSelector(getDealsData, (dealsData) => dealsData[id]);
